import Styles from './RadarChart.module.scss';

// Module import.
import { Radar } from 'react-chartjs-2';
import { Bar } from 'react-chartjs-2';
import { Line } from 'react-chartjs-2';
import { PolarArea } from 'react-chartjs-2';
// Component import.
import { useTranslation } from 'components/lib';

export const RadarChart = ({ data, labels, selectedChart }) => {

    const { t } = useTranslation();
    const chartData = {
        labels: labels,
        datasets: [
            {
                label: t('QualityQuotient.QualityReport.chart.label'),
                data: data,
                backgroundColor: 'rgba(201,221,248, 0.4)',
                borderColor: '#1B6EDA',
                pointBackgroundColor: '#1450a0',
                pointBorderColor: '#fff',
                pointHoverBackgroundColor: '#fff',
                pointHoverBorderColor: 'rgba(255, 99, 132, 1)',
            },
        ],
    };

    const options = {
        scales: {
            r: {
                pointLabels: {
                    display: false // Hides the labels around the radar chart 
                },
                min: 0,
                max: 100,
                ticks: {
                    stepSize: 10,
                    callback: function (value, index, values) {
                        if (value === 60 || value === 90) {
                            return value;
                        } else {
                            return ''; // Hide other ticks
                        }
                    }
                },
            },
        },
        plugins: {
            legend: {
                display: false
            }
        }
    };

    const renderChart = () => {
        switch (selectedChart) {
            case 'Radar':
                return <Radar data={chartData} options={options} />;
            case 'Bar':
                return <Bar data={chartData} options={options} />;
            case 'Line':
                return <Line data={chartData} options={options} />;
            case 'PolarArea':
                return <PolarArea data={chartData} options={options} />;
            default:
                return <Bar data={chartData} options={options} />;
        }
    };

    return (
        <div id='chartContainer' className={Styles.chartContainer}>
            {renderChart()}
        </div>
    );
}